import { render, staticRenderFns } from "./PersonRegistrationCandidateSearchInput.vue?vue&type=template&id=2d65db8e&scoped=true"
import script from "./PersonRegistrationCandidateSearchInput.vue?vue&type=script&lang=ts"
export * from "./PersonRegistrationCandidateSearchInput.vue?vue&type=script&lang=ts"
import style0 from "./PersonRegistrationCandidateSearchInput.vue?vue&type=style&index=0&id=2d65db8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d65db8e",
  null
  
)

export default component.exports